"use client";

import { Kbd, KbdGroup } from "@workspace/ui/components/kbd";
import { useEffect, useState } from "react";
import { isMac as checkIsMac } from "@workspace/ui/lib/platform";

type KeyboardShortcutProps = {
  keyLabel: string;
  modifier?: "cmd" | "ctrl";
};

export function KeyboardShortcut({
  keyLabel,
  modifier,
}: KeyboardShortcutProps) {
  const [isMac, setIsMac] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsMac(checkIsMac()), 0);
  }, []);

  const modifierKey = (() => {
    if (modifier === "cmd") {
      return isMac ? "⌘" : "Ctrl";
    }
    if (modifier === "ctrl") {
      return "Ctrl";
    }
    return "";
  })();

  if (modifier) {
    return (
      <KbdGroup className="hidden md:inline-flex">
        <Kbd suppressHydrationWarning>{modifierKey}</Kbd>
        <Kbd>{keyLabel}</Kbd>
      </KbdGroup>
    );
  }

  return <Kbd className="hidden md:inline-flex">{keyLabel}</Kbd>;
}
